import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { c as k } from "./clsx-OuTLNxxd.js";
import { I as o } from "./icon-B72I4fRl.js";
import "./components/elements/icon/iconsList.js";
import { useCounter as x } from "./components/elements/inputs/counter/counter.hooks.js";
const f = "_container_ke3mt_29", h = "_error_ke3mt_46", y = "_disabled_ke3mt_49", C = "_label_ke3mt_73", e = {
  container: f,
  error: h,
  disabled: y,
  "group-container": "_group-container_ke3mt_65",
  "full-width": "_full-width_ke3mt_70",
  label: C,
  "helper-text": "_helper-text_ke3mt_83"
}, j = ({
  inputInitialValue: c,
  placeholderForZero: r,
  onChange: m,
  minValue: d = 0,
  maxValue: u = 1e3,
  disabled: n = !1,
  hasError: a
}) => {
  const { value: l, increment: _, decrement: b, incrementIsDisabled: s, decrementIsDisabled: i } = x(
    c,
    d,
    u,
    n,
    m
  );
  return /* @__PURE__ */ p("div", { className: e.container, children: [
    /* @__PURE__ */ t("button", { type: "button", onClick: b, disabled: i, "aria-label": "counter-decrementer", children: /* @__PURE__ */ t(
      o,
      {
        className: `${i && e.disabled} ${a && e.error}`,
        name: "minus",
        size: "2xl"
      }
    ) }),
    /* @__PURE__ */ t(
      "input",
      {
        className: k(n && e.disabled),
        readOnly: !0,
        type: "text",
        value: l === 0 && r ? r : l,
        "aria-label": "input-value"
      }
    ),
    /* @__PURE__ */ t("button", { type: "button", onClick: _, disabled: s, "aria-label": "counter-incrementer", children: /* @__PURE__ */ t(
      o,
      {
        className: `${s && e.disabled} ${a && e.error}`,
        name: "plus",
        size: "2xl"
      }
    ) })
  ] });
};
export {
  j as C,
  e as s
};
